/**
 * CONFIGURADOR DE USUARIO - Guarda el estado del usuario actual
 * Para que los utils y logger funcionen correctamente
 */

// Función para configurar el usuario actual en el sistema
export const configurarUsuarioActual = (user) => {
    if (typeof window !== 'undefined') {
        // Guardar en localStorage para persistencia
        localStorage.setItem('currentUser', JSON.stringify(user));
        
        // Guardar en window para acceso inmediato
        window.currentUser = user;
        
        // Configurar logger si está disponible
        if (window.logger) {
            window.logger.setUsuario(user);
        }
        
        console.log(`👤 Usuario configurado: ${user.nombre} (${user.rol})`);
    }
};

// Función para obtener el usuario actual
export const obtenerUsuarioActual = () => {
    if (typeof window !== 'undefined') {
        // Intentar obtener de window primero
        if (window.currentUser) {
            return window.currentUser;
        }
        
        // Fallback a localStorage
        try {
            const stored = localStorage.getItem('currentUser');
            if (stored) {
                const user = JSON.parse(stored);
                window.currentUser = user; // Sincronizar con window
                return user;
            }
        } catch (error) {
            console.warn('Error al obtener usuario de localStorage:', error);
        }
    }
    
    return null;
};

// Función para limpiar el usuario actual
export const limpiarUsuarioActual = () => {
    if (typeof window !== 'undefined') {
        localStorage.removeItem('currentUser');
        delete window.currentUser;
        console.log('👤 Usuario desconfigurado');
    }
};

// 👤 USER CONFIG: Exportar funciones de configuración de usuario
const userConfig = {
    configurarUsuarioActual,
    obtenerUsuarioActual,
    limpiarUsuarioActual
};

export default userConfig;